export const steps = [
  {
    step: 1,
    image: '/assets/images/offlineGC/illus1.jpg',
    text: 'Go to the cashier and get the items billed'
  },
  {
    step: 2,
    image: '/assets/images/offlineGC/illus2.jpg',
    text: 'Get the final bill value from the cashier'
  },
  {
    step: 3,
    image: '/assets/images/offlineGC/illus3.jpg',
    text: 'Enter the bill amount and get the voucher codes'
  },
  {
    step: 4,
    image: '/assets/images/offlineGC/illus4.jpg',
    text: 'Show the voucher codes to the cashier'
  }
];
